import { Brand } from '@blade/std-lib'

export const CommentIdTypeId = 'tradebot-tma/CommentId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CommentIdTypeId = typeof CommentIdTypeId

export type CommentId = Brand.Branded<string, CommentIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentId = Brand.nominal<CommentId>()
